<template>
	<div class="results-window m-md-2" id="new">
		<div class="nutnosti-title" > Informace: </div>
		<div v-if="! infoLoading">
			<OneLineResult v-if="infoData.lastSearched" :propName="'Naposledy zobrazeno'" :requiredProp="infoData.lastSearched" />
			<OneLineResult :propName="'RUIAN'" :requiredProp="infoData.adresniMisto" />
			<OneLineResult :propName="'Bezdrát na úrovni města'" :requiredProp="infoData.bezdrat" />
			<OneLineResult :propName="'Poznámka'" :requiredProp="infoData.poznamka" />
		</div>
		<div v-else class="loading">
			<tile :loading="true" :height="'4'" :width="'4'" class="loading-icon"></tile>
		</div>


		<NejPripoResult v-if="nejPripoShow" :results="nejpripoData" :loading="nejpripoLoading" />

		<VodafoneResult v-if="vodafoneShow" :results="vodafoneData" :loading="vodafoneLoading" />

		<StarNetResult  v-if="starNetShow" :result="starNetData" :loading="starNetLoading" />

		<!-- UVT data {{ thisUVTdata }} -->
		<!-- 1: {{ UVTloading }} - 2: {{ this.UVTloading }} - 3: {{ UVTdata }} - 4: {{ this.UVTdata }} -->

		<!-- <CetinResult v-if="cetinShow" :results="cetinData" :loading="cetinLoading" :cetinHold="cetinHold" /> -->

		<!-- <CetinBondingResult v-if="! cetinLoading" :results="cetinIsBonding" /> -->

		<OrelSoftResult v-if="orelSoftShow" :results="orelSoftData" :add="orelSoftDataCategory" :info="orelSoftDataInfo" :loading="orelSoftLoading" />
		<TlapkaResult v-if="tlapkaShow" :data="tlapkaData" :loading="tlapkaLoading" />

		<SprintelResult :results="sprintelData" :loading="sprintelLoading" />

		<NordicResult :results="nordicData" :loading="nordicLoading" />
		<UVTResult v-if="UVTshow" :results="UVTdata" :loading="UVTloading" />

		<DluzniciResult :results="dluzniciData" :loading="dluzniciLoading" />
		<button @click="fetchApiData" v-if="! hideApiButton"> Api dotaz </button>
		<GoogliApiResult :results="apiData" :loading="googliApiDataLoading" />

		<div class="map-container" v-if="mapData !== null && mapData.coords !== null">
			<Map class="business-map" :myCoords="mapData.coords" />
		</div>
	</div>
</template>

<script>
import AdditionsService from '@/services/AdditionsService'

import OneLineResult from '@/components/search_provider/results/OneLineResult.vue'
import NejPripoResult from '@/components/search_provider/results/NejPripoResult.vue'
import StarNetResult from '@/components/search_provider/results/StarNetResult.vue'
import CetinResult from '@/components/search_provider/results/CetinResult.vue'
import CetinBondingResult from '@/components/search_provider/results/CetinBondingResult.vue'
import SprintelResult from '@/components/search_provider/results/SprintelResult.vue'
import NordicResult from '@/components/search_provider/results/NordicResult.vue'
import GoogliApiResult from '@/components/search_provider/results/GoogliApiResult.vue'
import DluzniciResult from '@/components/search_provider/results/DluzniciResult.vue'
import OrelSoftResult from '@/components/search_provider/results/OrelSoftResult.vue'
import UVTResult from '@/components/search_provider/results/UVTResult.vue'
import TlapkaResult from '@/components/search_provider/results/TlapkaResult.vue'
import VodafoneResult from '@/components/search_provider/results/VodafoneResult.vue'

import { mapGetters } from 'vuex'

export default {
	name: 'SearchProviderResults',

	components: {
		Map: () => import('../Map.vue'),
		OneLineResult,
		NejPripoResult,
		StarNetResult,
		CetinResult,
		CetinBondingResult,
		SprintelResult,
		NordicResult,
		DluzniciResult,
		OrelSoftResult,
		GoogliApiResult,
		UVTResult,
		TlapkaResult,
		VodafoneResult
	},

	props: {
		hResults: Object,
		searchAddress: null,
	},

	data () {
		return {
			user: null,

			infoData: null,
			infoLoading: true,

			nejpripoData: null,
			nejpripoLoading: true,
			nejPripoShow: true,

			starNetData: null,
			starNetLoading: true,
			starNetShow: true,

			UVTshow: true,
			UVTloading: true,
			UVTdata: {},

			tlapkaShow: true,
			tlapkaLoading: true,
			tlapkaData: {},

			// cetinData: null,
			// cetinIsBonding: [],
			// cetinLoading: true,
			// cetinShow: true,
			// cetinHold: null,

			sprintelData: null,
			sprintelLoading: true,

			nordicData: null,
			nordicLoading: true,

			dluzniciData: null,
			dluzniciLoading: true,

			orelSoftData: null,
			orelSoftDataCategory: '',
			orelSoftDataInfo: '',
			orelSoftShow: true,
			orelSoftLoading: true,

			mapData: null,

			apiData: {},
			googliApiDataLoading: false,
			hideApiButton: false,

			vodafoneData: [],
			vodafoneLoading: true,
			vodafoneShow: true,
		}
	},

	mounted () {
		this.$forceUpdate();
	},

	methods: {
		...mapGetters([
			'getUserObject',
		]),

		getUserName () {
			const user = this.getUserObject()
			return user.name
		},

		logFailedReason (err) {
			if (err.response) {
				console.log(err.response.data)
				return
			}
		},

		fetchData () {
			this.infoData = null
			this.nejpripoData = null
			this.starNetData = null
			this.cetinData = null
			this.sprintelData = null
			// this.cetinHold = null
			this.mapData = null
			this.orelSoftData = null
			this.orelSoftDataCategory = ''
			this.orelSoftDataInfo = ''
			this.apiData = {}
			this.hideApiButton = false
			this.UVTdata = null
			this.tlapkaData = null
			this.vodafoneData = []

			this.fetchInfoData()
			this.fetchNejpripoData()
			this.fetchStarnetData()
			this.fetchUVTdata()
			// this.fetchCetinData()
			this.fetchOrelSoftData()
			this.fetchSprintelData()
			this.fetchNordicData()
			this.fetchDluzniciProducts()
			this.fetchAddressCoords()
			this.fetchTlapkaData()
			this.fetchVodafoneData()
		},

		async fetchInfoData () {
			this.infoLoading = true
			try {
				const infoData = await AdditionsService.fetchInfoData(this.searchAddress, this.getUserName())
				this.infoData = infoData.data
				this.infoLoading = false
				this.$emit('stopLoading')
			} catch (e) {
				this.logFailedReason(e)
				this.infoLoading = false
			}
		},

		async fetchNejpripoData () {
			this.nejpripoLoading = true
			this.nejpripoShow = true
			try {
				const nejpripoData = await AdditionsService.fetchNejpripoData(this.searchAddress, this.getUserName())
				this.nejpripoData = nejpripoData.data
				if (this.nejpripoData.length < 1) {
					this.nejPripoShow = false
				}
				this.nejpripoLoading = false
				this.$emit('stopLoading')

			} catch (e) {
				this.logFailedReason(e)
				this.nejpripoLoading = false
			}
		},

		async fetchVodafoneData() {
			console.log('fetchVOdafoneData')
			this.vodafoneLoading = true
			this.vodafoneShow = true
			try {
				const vodaData = await AdditionsService.fetchVodafoneData(this.searchAddress, this.getUserName())
				this.vodafoneData = vodaData.data
				if (this.vodafoneData.length > 0) {
					this.$emit('stopLoading')
				}
				if (this.vodafoneData.length === 0) {
					this.vodafoneShow = false
				}
				this.vodafoneLoading = false

			} catch (e) {
				this.logFailedReason(e)
				this.vodafoneLoading = false
				this.vodafoneShow = false
				this.vodafoneData = []
			}
		},

		async fetchStarnetData () {
			this.starNetLoading = true
			try {
				const starNetData = await AdditionsService.fetchStarnetProducts(this.searchAddress, this.getUserName())
				this.starNetData = starNetData.data
				if (starNetData.data.hasOwnProperty('noDisplay') && starNetData.data.noDisplay) {
					this.starNetShow = false
					this.starNetLoading = false

					return
				}
				this.starNetLoading = false
				this.$emit('stopLoading')

			} catch (e) {
				this.logFailedReason(e)
				this.starNetLoading = false
			}
		},

		async fetchOrelSoftData () {
			this.orelSoftLoading = true
			try {
				const orelSoftData = await AdditionsService.fetchOrelSoftAvailability(this.searchAddress, this.getUserName())
				this.orelSoftLoading = false

				if (! orelSoftData || ! orelSoftData.data) {
					this.orelSoftData = false;
					return
				}

				if (orelSoftData.data.state !== 'success') {
					this.orelSoftData = false;

					return
				}

				if (orelSoftData.data.inside === 'false') {
					this.orelSoftData = false;
				}
				if (orelSoftData.data.inside === 'true') {

					this.orelSoftData = true;
					this.orelSoftDataCategory = orelSoftData.data.category;
					this.orelSoftDataInfo = orelSoftData.data.info;
				}

				this.orelSoftLoading = false
				this.$emit('stopLoading')
			} catch (e) {
				this.logFailedReason(e)
				this.orelSoftLoading = false
			}
		},

		async fetchUVTdata () {
			this.UVTloading = true
			this.UVTshow = true
			try {
				const UVTdataHold = await AdditionsService.fetchUVTAvailability(this.searchAddress, this.getUserName())
				// console.log({ UVTdataHold });
				if (!UVTdataHold || !UVTdataHold.data || UVTdataHold.data.failed) {
					console.log('UVT DATA SE NEZDARILO', UVTdataHold.data.message);
					this.UVTloading = false
					this.UVTshow = false
					return
				}
				console.log('zdarilo')

				this.UVTdata = UVTdataHold.data.products;
				this.UVTloading = false;
				console.log({ uvt: this.UVTdata });
				// this.$forceUpdate();
			} catch (e) {
				this.logFailedReason(e);
				// this.UVTshow = false
				this.UVTloading = false
			}
		},

		async fetchTlapkaData() {
			this.tlapkaLoading = true
			this.tlapkaShow = true

			try {
				const tlapkaDataHold = await AdditionsService.fetchTlapkaAvailability(this.searchAddress, this.getUserName());
				this.tlapkaData = tlapkaDataHold.data;
				this.tlapkaLoading = false;
			} catch (e) {
				this.logFailedReason(e);
			}
		},

		async fetchCetinData () {
			this.cetinLoading = true
			this.cetinShow = true
			try {
				const cetinData = await AdditionsService.fetchCetinProducts(this.searchAddress, this.getUserName())
				this.cetinData = cetinData.data
				this.cetinIsBonding = cetinData.data.isBonding
				if ((! cetinData.data.cetinToBeAvailable.length) && (! cetinData.data.finalAttributy.length) && (! cetinData.data.finalNutnosti.length) && (! cetinData.data.isBonding.length)) {
					this.cetinHold = 'Nelze určit dostupnost služeb.'
				}
				this.cetinLoading = false
				this.$emit('stopLoading')

			} catch (e) {
				this.logFailedReason(e)
				this.cetinLoading = false
			}
		},

		async fetchSprintelData () {
			this.sprintelLoading = true
			try {
				const sprintelData = await AdditionsService.fetchSprintelProducts(this.searchAddress, this.getUserName())
				this.sprintelData = sprintelData.data

				this.sprintelLoading = false
				this.$emit('stopLoading')

			} catch (e) {
				this.logFailedReason(e)
				this.sprintelLoading = false
			}
		},

		async fetchNordicData () {
			this.nordicLoading = true
			this.nordicData = {}
			try {
				const nordicData = await AdditionsService.fetchNordicProducts(this.searchAddress, this.getUserName())
				this.nordicData = nordicData.data

				this.nordicLoading = false
				this.$emit('stopLoading')

			} catch (e) {
				this.logFailedReason(e)
				this.nordicLoading = false
			}
		},

		async fetchDluzniciProducts () {
			this.dluzniciLoading = true
			try {
				const dluzniciData = await AdditionsService.fetchDluzniciProducts(this.searchAddress, this.getUserName())
				this.dluzniciData = dluzniciData.data

				this.dluzniciLoading = false
				this.$emit('stopLoading')

			} catch (e) {
				this.logFailedReason(e)
				this.dluzniciLoading = false
			}
		},

		async fetchApiData() {
			this.googliApiDataLoading = true
			const apiData = await AdditionsService.fetchApiData(this.searchAddress)
			if (apiData.hasOwnProperty('data') && apiData.data.hasOwnProperty('apiData') && apiData.data.apiData.statusCode === 200) {
				this.apiData = JSON.parse(apiData.data.apiData.body)
				console.log(this.apiData)
			}
			this.googliApiDataLoading = false
			this.hideApiButton = true
		},

		async fetchAddressCoords () {
			try {
				const mapData = await AdditionsService.fetchAddressCoords(this.searchAddress, this.getUserName())
				this.mapData = mapData.data
			} catch (e) {
				this.logFailedReason(e)
			}
		}

	},

	watch: {
		searchAddress: {
			immediate: true,
			handler (to) {
				if (to) {
					this.fetchData()
				}
			}
		}

	}
}
</script>

<style lang="stylus" scoped>
.results-window
	border-radius 20px
	margin-top 30px
	margin-left 30px
	display flex
	flex-direction column
	text-align left
	padding 15px

.map-container
	width 800px
	height 400px
	border 2px solid black

.nutnosti-title
	font-size 24px
	font-weight bold

.loading-icon
	height 50px
	padding 0px !important
	margin-top -100px !important

.cetin-data
	padding-top 10px
	margin-top 15px
	border-bottom 1px solid #4CA5F9
	border-top 1px solid #4CA5F9

.company-name
	font-weight bold
	font-size 24px

.cetin-vysledek
	display flex
	flex-direction column
	border-bottom 1px dashed #4CA5F9
	border-top 1px dashed #4CA5F9

.cetin-vysledek-card
	padding 10px
	background-color white
	border-radius 5px
	margin-right 10px
	margin-bottom 10px

@media (max-width 1000px)
	.results-window
		margin-top 5px
		margin-left 0px

	.map-container
		width 100%
		height 200px
		border 2px solid black
</style>



// WEBPACK FOOTER //
// src/components/search_provider/SearchProviderResults.vue